/** Anchos mínimos para columnas con texto largo (chasis, contacto, etc.). */
const COLUMN_MIN_WIDTHS = {
  chassisNumber: '11rem',
  engineNumber: '10rem',
  chassisInfo: '11rem',
  plate: '6.5rem',
  representative: '10rem',
  representativeContact: '9rem',
  name: '12rem',
  description: '14rem',
  customerName: '11rem',
  clientName: '11rem',
  documentNumber: '9rem',
  invoiceNumber: '8rem',
};

/** meta de layout para Th/Td (TanStack). */
export function getColumnLayoutMeta(col) {
  const meta = {};
  if (col.width) meta.width = col.width;
  if (col.minWidth) meta.minWidth = col.minWidth;
  if (col.maxWidth) meta.maxWidth = col.maxWidth;
  if (col.whiteSpace) meta.whiteSpace = col.whiteSpace;

  const accessorKey = typeof col.accessor === 'string' ? col.accessor : '';
  const preset = COLUMN_MIN_WIDTHS[accessorKey];
  if (preset && !meta.minWidth && !meta.width) {
    meta.minWidth = preset;
  }

  if (!meta.minWidth && accessorKey) {
    if (/chassis|chasis|engine|motor|identif|vin|comprobante/i.test(accessorKey)) {
      meta.minWidth = '11rem';
    }
  }

  return meta;
}

/** Opciones comunes para columnas ordenables en tablas admin. */
export function getSortableColumnOptions(col) {
  return {
    id: col.accessor,
    enableSorting:
      col.enableSorting !== false && Boolean(col.Header) && !col.actions,
    meta: getColumnLayoutMeta(col),
  };
}
